import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, Query } from '@datorama/akita';
import { Cmg1003CoverLetterSubmissionsStore } from './cover-letter-submissions.store';
import { CoverLetterSubmissionNotes } from '../../cmg-1003/models/cover-letter-submission-notes.model';

@Injectable({ providedIn: 'root' })
export class Cmg1003CoverLetterSubmissionsQuery extends Query<CoverLetterSubmissionNotes> {
  protected store: Cmg1003CoverLetterSubmissionsStore;

  options = {
    // return true if not equal
    comparator: (a, b) => {
      for (const [key, updatedValue] of Object.entries(b)) {
        const initialValue = !!a && key in a ? a[key] : '';
        if ((updatedValue ?? '') !== (initialValue ?? '')) {
          return true;
        }
      }
      return false;
    },
  };
  dirtyChecker = new DirtyCheckPlugin(this, this.options);

  constructor() {
    const store = inject(Cmg1003CoverLetterSubmissionsStore);

    super(store);

    this.store = store;
  }
}
